module.exports = __webpack_public_path__ + "img/verification.c3837c05.svg";